import qs from 'qs';
import { network } from 'services/network';
import { useMutation } from 'react-query';

const changeNlpThresholds = (params) => {
    const querystring = qs.stringify(
        {
            ProjectId: params.projectId,
            clusterAbvs: params.clusterAbvs,
            clusterThreshold: params.clusterThreshold,
            minInCluster: params.minInCluster,
            clusterServiceType: params.clusterServiceType,
        },
        { addQueryPrefix: true, skipNulls: true },
    );
    const url = `api/bo/changeClusterType${querystring}`;
    return network.post(url).then((response) => {
        return response.data;
    });
};

interface Params {
    projectId: number | undefined;
    clusterAbvs: number;
    clusterThreshold: number;
    minInCluster: number;
    clusterServiceType: string;
}

export const useMutationChangeNlpThresholds = () => {
    return useMutation((params: Params) => changeNlpThresholds(params));
};
